// extracted by mini-css-extract-plugin
module.exports = {"mainContainer":"LoginNavButtons_mainContainer__1venB","content":"LoginNavButtons_content__1PN6a","divider":"LoginNavButtons_divider__3QqdT","link":"LoginNavButtons_link__3nUkX"};